import layout from '../layout.vue';
const _import = (file) => import(`./pages/${file}.vue`)

export default {
    path: '/order/',
    component:layout,
    children:[
		{name: '保单列表', path: 'index', component: ()=>_import('index')},
		{name: '理赔申请', path: 'claim', component: ()=>_import('claim')},
		{name: '售后订单', path: 'refund', component: ()=>_import('refund')},
        // add route here
    ]
}